import { connect } from 'react-redux';
import { connectActionObject, connectStoreMethod, StepsClass } from './Steps';

class StepsAutomaticAddStep extends StepsClass {
  componentDidMount() {
    super.componentDidMount();
    this.addStep();
  }
}

export default connect(
  connectStoreMethod,
  connectActionObject,
)(StepsAutomaticAddStep);
